<template>
    <div v-resize="onResize">
        <v-navigation-drawer v-model="drawer" fixed clipped app :mobile-break-point="mobileBreakPoint" width="240">
            <v-list :dense="false">
                <v-list-tile v-for="item in items" :key="item.text" @click="goToRoute(item.route)">
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ $t(item.text) }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        
        <v-toolbar color="red" dense fixed clipped-left clipped-right app>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <img src="../assets/guitar.png" height="28" alt="Chords" class="logo ml-3">
            <v-toolbar-title class="align-center">
                <span class="ml-0 font-weight-regular">Chords Grid Editor</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div>
                <!-- <v-btn flat @click="goToRoute('/login')" class="hidden-xs-only">
                    {{ $t('sign-in') }}
                </v-btn> -->
                <v-menu bottom left>
                    <v-btn slot="activator" dark icon>
                        <v-icon>language</v-icon>
                    </v-btn>
                    <v-list>
                        <v-list-tile v-for="(locale, key) in locales" :key="key" @click="changeLocale(key)">
                            <v-list-tile-title>{{ $t(locale) }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </v-toolbar>

        <v-content>
            <v-container fluid>
                <v-layout justify-center>
                    <v-flex>
                        <router-view :key="$route.fullPath"/>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>

        <v-footer class="pa-3" absolute>
            <div class="footer">Fabien Bellanger &copy; {{ new Date().getFullYear() }} - Version {{ version }}</div>
        </v-footer>

        <transition name="fadeSlide">
            <div class="cookies" v-if="!acceptCookiesInformation" transition="fade-transition">
                {{ $t('cookies-information') }}
                <v-btn flat icon small color="white" @click="acceptCookies()">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as types from '@/stores/types';
import store from '@/stores';
import moment from 'moment';

export default {
    store,
    data: () => ({
        mobileBreakPoint: 1235,
        drawer:           (window.innerWidth > 1235),
        locales:          {
            'fr': 'french',
            'en': 'english',
        },
        acceptCookiesInformation: !!JSON.parse(localStorage.getItem('acceptCookies')),
    }),
    computed: {
        ...mapGetters({
            version:       'version',
            isMobile:      'isMobile',
            userConnected: 'userConnected',
        }),
        items: function()
        {
            const list = [];

            list.push({ icon: 'home', text: 'home', route: '/' });
            list.push({ icon: 'list', text: 'songs-list', route: '/songs-list' });

            if (!this.isMobile)
            {
                list.push({ icon: 'music_note', text: 'new-song', route: '/new-song' });
            }

            list.push({ icon: 'info', text: 'about', route: '/about' });
            list.push({ icon: 'history', text: 'versions-history', route: '/versions' });

            return list;
        },
    },
    methods: {
        ...mapActions({
            isMobileAction: types.A_APP_ISMOBILE,
        }),
        /**
         * Aller vers la route
         *
         * @author Fabien Bellanger
         * @param {String} route Route
         */
        goToRoute: function(route)
        {
            this.$router.push(route);
        },
        /**
         * Modification de la locale
         *
         * @author Fabien Bellanger
         * @param {String} locale Locale
         */
        changeLocale: function(locale)
        {
            this.$i18n.locale = locale;
            
            // Changement de la locale de Moment.js
            // ------------------------------------
            moment.locale(locale);
        },
        /**
         * Valide l'acceptation des cookies
         *
         * @author Fabien Bellanger
         */
        acceptCookies: function()
        {
            this.acceptCookiesInformation = true;

            localStorage.setItem('acceptCookies', this.acceptCookiesInformation);
        },
        /**
         * Redimensionnement de la fenêtre
         *
         * @author Fabien Bellanger
         */
        onResize: function()
        {
            if (window.innerWidth < 800)
            {
                if (!this.isMobile)
                {
                    this.isMobileAction(true);
                }
            }
            else
            {
                if (this.isMobile)
                {
                    this.isMobileAction(false);
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
    .logo {
        filter: invert(1);
    }

    .footer {
        font-size: 12px;
        margin:    0 auto;
        color:     #999;
    }

    // Transaction fadeSlide
    .fadeSlide-enter-active, .fadeSlide-leave-active {
        transition: all .7s ease;
    }

    .fadeSlide-enter, .fadeSlide-leave-to {
        opacity:   0;
        transform: translate(100vw, 0);
    }

    .cookies {
        position:         fixed;
        bottom:           0px;
        left:             0px;
        right:            0px;
        height:           36px;
        z-index:          100;
        display:          flex;
        justify-content:  center;
        align-items:      center;
        background-color: rgba($color: #f44336, $alpha: 0.8);
    }
</style>
